import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as styles from './styles';

import {
  type AppState,
  loadVehiclesRequest,
  selectVehiclesInOrder,
} from '@cobliteam/store';

import { PanelTab, PanelTabs } from '@cobliteam/base-components';
import withPermission from '@cobliteam/base-components/src/PermissionsGate/PermissionsGate';

import MaintenancePermissions from '../../permissions';
import { DeleteRemindersModalContainer } from '../DeleteRemindersModal/DeleteRemindersModalContainer';
import { EditRemindersModalContainer } from '../EditRemindersModal/EditRemindersModalContainer';
import { MaintenanceHistoryContainer } from '../MaintenanceHistory/MaintenanceHistoryContainer';
import { MaintenancePaper } from '../MaintenancePaper/MaintenancePaper';
import { MaintenanceRemindersContainer } from '../MaintenanceReminders/MaintenanceRemindersContainer';
import { RegistrationModalContainer } from '../RegistrationModal/RegistrationModalContainer';
import { SetupRemindersModalContainer } from '../SetupRemindersModal/SetupRemindersModalContainer';

export enum TabType {
  REMINDERS = 'reminders',
  HISTORY = 'history',
}

const MaintenancePage = () => {
  const dispatch = useDispatch();
  const vehiclesWebData = useSelector((state: AppState) =>
    selectVehiclesInOrder(state)
  );

  const [selectedTab, setSelectedTab] = React.useState(TabType.REMINDERS);

  const [isSetupReminderModalOpen, setIsSetupReminderModalOpen] =
    React.useState(false);
  const [isEditReminderModalOpen, setIsEditReminderModalOpen] =
    React.useState(false);
  const [isDeleteReminderModalOpen, setIsDeleteReminderModalOpen] =
    React.useState(false);
  const [isRegistrationModalOpen, setIsRegistrationModalOpen] =
    React.useState(false);

  const handleTabChange = (_: React.ChangeEvent<{}>, value: TabType) =>
    setSelectedTab(value);

  const onLoadPageContent = () => {
    dispatch(loadVehiclesRequest());
  };

  return (
    <MaintenancePaper>
      <PanelTabs
        centered
        className={styles.tabs}
        value={selectedTab}
        onChange={handleTabChange}
      >
        <PanelTab
          disableRipple
          label='Lembretes de manutenção'
          value={TabType.REMINDERS}
        />
        <PanelTab
          disableRipple
          label='Histórico de manutenções'
          value={TabType.HISTORY}
        />
      </PanelTabs>

      {selectedTab === TabType.REMINDERS && (
        <MaintenanceRemindersContainer
          vehiclesWebData={vehiclesWebData}
          onRegisterReminderClick={() => setIsSetupReminderModalOpen(true)}
          onEditRemindersClick={() => setIsEditReminderModalOpen(true)}
          onDeleteRemindersClick={() => setIsDeleteReminderModalOpen(true)}
          onMarkAsDoneClick={() => setIsRegistrationModalOpen(true)}
          onLoadPageContent={onLoadPageContent}
        />
      )}
      {selectedTab === TabType.HISTORY && (
        <MaintenanceHistoryContainer
          vehiclesWebData={vehiclesWebData}
          onEditMaintenanceClick={() => setIsRegistrationModalOpen(true)}
          onRegisterMaintenanceClick={() => setIsRegistrationModalOpen(true)}
          onLoadPageContent={onLoadPageContent}
        />
      )}

      {isSetupReminderModalOpen && (
        <SetupRemindersModalContainer
          vehiclesWebData={vehiclesWebData}
          onClose={() => setIsSetupReminderModalOpen(false)}
        />
      )}

      {isEditReminderModalOpen && (
        <EditRemindersModalContainer
          vehiclesWebData={vehiclesWebData}
          onClose={() => setIsEditReminderModalOpen(false)}
        />
      )}

      {isDeleteReminderModalOpen && (
        <DeleteRemindersModalContainer
          vehiclesWebData={vehiclesWebData}
          onClose={() => setIsDeleteReminderModalOpen(false)}
        />
      )}

      {isRegistrationModalOpen && (
        <RegistrationModalContainer
          vehiclesWebData={vehiclesWebData}
          onClose={() => setIsRegistrationModalOpen(false)}
        />
      )}
    </MaintenancePaper>
  );
};

export default withPermission(
  MaintenancePermissions.FULL_CONTROL_MAINTENANCE,
  MaintenancePage
);
